import { RecurringTypesEnum, SubscriptionProductModel } from "dash-common";
import { SubscriptionProduct } from "gql/generated.graphql";

export function getPricePerMonth(subscription: SubscriptionProduct) {
  if (subscription.recurringType === RecurringTypesEnum.SIXMONTH) {
    return subscription.price / 6;
  } else if (subscription.recurringType === RecurringTypesEnum.MONTH) {
    return subscription.price;
  } else {
    return 0;
  }
}

export const isLowerPricePerMonth = (
  newProduct: SubscriptionProduct,
  oldProduct: SubscriptionProduct
) => getPricePerMonth(newProduct) < getPricePerMonth(oldProduct);

export const isHigherPricePerMonth = (
  newProduct: SubscriptionProduct,
  oldProduct: SubscriptionProduct
) => getPricePerMonth(newProduct) > getPricePerMonth(oldProduct);

export function getChangeType(
  oldProduct?: SubscriptionProductModel,
  newProduct?: SubscriptionProductModel
) {
  if (!oldProduct || !newProduct) return "UPGRADE";

  if (
    oldProduct.stripeProductId === newProduct.stripeProductId &&
    oldProduct.price !== newProduct.price
  ) {
    return newProduct.recurringType === RecurringTypesEnum.MONTH
      ? "MONTH"
      : "SIXMONTH";
  }

  const oldPricePerMonth = getPricePerMonth(oldProduct);
  const newPricePerMonth = getPricePerMonth(newProduct);

  if (newPricePerMonth > oldPricePerMonth) {
    return "UPGRADE";
  } else if (newPricePerMonth < oldPricePerMonth) {
    return "DOWNGRADE";
  } else {
    return "UNCHANGED";
  }
}

export const getProductNameSlug = (product: SubscriptionProduct) => {
  return `${product?.name?.toLowerCase().split(" ").join("-")}`;
}